module.exports = __webpack_public_path__ + "static/AngelaHe3-d6e00051f8747f8411a74b4207d09134.webp";